/* Health IQ theme v6 — animated hero + B2B savings calculator */
(function () {
  'use strict';
  var HQ = window.HQ || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  function motionOff() {
    var m = document.documentElement.getAttribute('data-motion');
    if (m === 'off') return true;
    return !!(m === 'respect' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function formatMoney(cents) {
    var value = Number(cents) / 100, whole = Math.round(value) === value;
    var amount = value.toLocaleString('en-IN', { minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 });
    return (HQ.moneyFormat || '₹{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function initHeroMotion(ctx) {
    $$('[data-hm]', ctx).forEach(function (root) {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      var words = $$('[data-hm-word]', root), heroes = $$('[data-hm-hero]', root), floats = $$('[data-hm-float]', root);
      var bubs = $$('[data-hm-bub]', root), dots = $$('[data-hm-dot]', root), stage = $('[data-hm-stage]', root);
      var n = heroes.length; if (!n) return;
      var dur = (parseInt(root.getAttribute('data-hm-duration'), 10) || 4) * 1000;
      var cur = 0, timer = null, paused = false, visible = true;
      function schedule() { clearTimeout(timer); if (paused || !visible || motionOff() || n < 2) return; timer = setTimeout(function () { go(cur + 1); }, dur); }
      function go(i) {
        var prev = cur; cur = (i + n) % n;
        words.forEach(function (w, k) {
          w.classList.remove('is-out');
          if (k === prev && prev !== cur) w.classList.add('is-out');
          w.classList.toggle('is-active', k === cur);
          w.setAttribute('aria-hidden', k === cur ? 'false' : 'true');
        });
        [heroes, floats, bubs, dots].forEach(function (list) { list.forEach(function (el, k) { el.classList.toggle('is-active', k === cur); }); });
        dots.forEach(function (d, k) { d.setAttribute('aria-selected', k === cur ? 'true' : 'false'); });
        schedule();
      }
      bubs.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      if (stage) {
        stage.addEventListener('mouseenter', function () { paused = true; clearTimeout(timer); });
        stage.addEventListener('mouseleave', function () { paused = false; schedule(); });
        if (!motionOff() && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
          var layers = $$('[data-depth]', root);
          layers.forEach(function (l) { l.style.setProperty('--dp', l.getAttribute('data-depth')); });
          root.addEventListener('mousemove', function (e) {
            var r = root.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
            layers.forEach(function (l) { l.style.setProperty('--px', (x * 24).toFixed(1)); l.style.setProperty('--py', (y * 24).toFixed(1)); });
          });
          root.addEventListener('mouseleave', function () { layers.forEach(function (l) { l.style.setProperty('--px', 0); l.style.setProperty('--py', 0); }); });
        }
      }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; schedule(); }); }, { threshold: 0.2 }).observe(root);
      setTimeout(schedule, 1200);
    });
  }

  function initCalc(ctx) {
    $$('[data-b2b-calc]', ctx).forEach(function (calc) {
      if (calc.dataset.ready) return; calc.dataset.ready = '1';
      var root = calc.closest('[data-b2b]') || document.body;
      var goalQty = parseInt(root.getAttribute('data-b2b-token-qty'), 10) || 50;
      var goalTok = parseInt(root.getAttribute('data-b2b-token-amount'), 10) || 2000;
      var cp = $('[data-calc-product]', calc), cq = $('[data-calc-qty]', calc), cqo = $('[data-calc-qty-out]', calc);
      var cr = $('[data-calc-retail]', calc), cb = $('[data-calc-b2b]', calc), cs = $('[data-calc-save]', calc), ct = $('[data-calc-tok]', calc), ctw = $('[data-calc-tok-wrap]', calc);
      function run() {
        if (!cp || !cq || !cp.options.length) return;
        var o = cp.options[cp.selectedIndex], q = parseInt(cq.value, 10) || 0;
        var retail = (parseInt(o.value, 10) || 0) * q, b2b = (parseInt(o.getAttribute('data-b2b'), 10) || 0) * q;
        if (cqo) cqo.textContent = q;
        if (cr) cr.textContent = formatMoney(retail);
        if (cb) cb.textContent = formatMoney(b2b);
        if (cs) cs.textContent = formatMoney(retail - b2b);
        var won = q >= goalQty;
        if (ct) ct.textContent = won ? '+' + goalTok.toLocaleString('en-IN') + ' bonus IQ Tokens' : 'Add ' + (goalQty - q) + ' more pcs for ' + goalTok.toLocaleString('en-IN') + ' bonus tokens';
        if (ctw) ctw.classList.toggle('is-off', !won);
        var min = parseFloat(cq.min) || 0, max = parseFloat(cq.max) || 100, pct = max > min ? (q - min) / (max - min) * 100 : 0;
        cq.style.background = 'linear-gradient(90deg,var(--hq-accent) ' + pct + '%,#EADFD6 ' + pct + '%)';
      }
      if (cp) cp.addEventListener('change', run);
      if (cq) cq.addEventListener('input', run);
      run();
    });
  }

  function initReorder(ctx) {
    $$('[data-b2b-reorder]', ctx).forEach(function (btn) {
      if (btn.dataset.ready) return; btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var items; try { items = JSON.parse(btn.getAttribute('data-b2b-reorder')); } catch (e) { return; }
        if (!items || !items.length) return;
        var code = btn.getAttribute('data-code') || '';
        btn.classList.add('is-loading');
        fetch(((HQ.routes && HQ.routes.cart_add) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) { btn.classList.remove('is-loading'); alertMsg(btn, (res.data && (res.data.description || res.data.message)) || 'Some items are no longer available.'); return; }
            window.location.href = code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart') : '/cart';
          })
          .catch(function () { btn.classList.remove('is-loading'); });
      });
    });
  }
  function alertMsg(btn, msg) {
    var t = document.getElementById('HQToast');
    if (t) { t.textContent = msg; t.classList.add('is-show'); setTimeout(function () { t.classList.remove('is-show'); }, 3500); }
  }

  function initAll(ctx) { initHeroMotion(ctx); initCalc(ctx); initReorder(ctx); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
